import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeKR from '@angular/common/locales/ko';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './component/app.component';
import { BookmarkListComponent } from './component/bookmark/bookmarkList.component';
import { BookmarkManagerComponent } from './component/bookmark/bookmarkManager.component';
import { ConfigurationComponent } from './component/configuration/configuration.component';
import { DroneSpecificationComponent } from './component/droneSpecification/droneSpecification.component';
import { FlightConfiguraitonComponent } from './component/flightConfiguration/flightConfiguration.component';
import { DoneComponent } from './component/join/done.component';
import { InfoComponent } from './component/join/info.component';
import { JoinComponent } from './component/join/join.component';
import { TermsComponent } from './component/join/terms.component';
import { LocationComponent } from './component/location/location.component';
import { MainComponent } from './component/main/main.component';
import { SearchComponent } from './component/search/search.component';
import { SummaryComponent } from './component/summary/summary.component';
import { UnitComponent } from './component/unit/unit.component';
import { WeatherTableComponent } from './component/weatherTable/weatherTable.component';
import { LocalizationSetting } from './config/localization.config';
import { RouterSetting } from './config/router.config';
import { AccountService } from './service/account/account.service';
import { DateService } from './service/date/date.service';
import { AuthInterceptor } from './service/http/auth.interceptor';
import { HttpService } from './service/http/http.service';
import { LocalizationProvider } from './service/localization/localization.provider';
import { LocalizationService } from './service/localization/localization.service';
import { PopupService } from './service/popup/popup.service';
import {CookieService} from "./service/cookie/cookie.service";
import {KeycloakService} from "./service/keycloak/keycloak.service";

registerLocaleData(localeKR);

@NgModule({
    declarations: [
        AppComponent,
        SummaryComponent,
        WeatherTableComponent,
        FlightConfiguraitonComponent,
        DroneSpecificationComponent,
        UnitComponent,
        JoinComponent,
        TermsComponent,
        InfoComponent,
        DoneComponent,
        MainComponent,
        SearchComponent,
        LocationComponent,
        BookmarkListComponent,
        BookmarkManagerComponent,
        ConfigurationComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        RouterSetting,
        LocalizationSetting
    ],
    providers: [
        HttpService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        AccountService,
        PopupService,
        DateService,
        LocalizationService,
        LocalizationProvider,
        CookieService,
        KeycloakService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
